<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Food-Intake</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm();selectFutureTime = false">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loader v-if="pageLoader"></loader>
                    <div class="form-group field-wrapper">
                        <select class="float-field form-control" name="food item" v-model="food_item" v-validate="'required'" >
                            <option disabled value="">Select an item...</option>
                            <option v-for="(item,key) in breakfastOptions"  :value="item.value"> {{item.label}} </option>
                        </select>
                        <p class="error" v-if="submitted" v-for="error in errors.collect('food item')">{{ error }}</p>
                    </div>

                    <div class="form-group field-wrapper">
                        <input type="text" class="float-field form-control" placeholder="Description"  name="description" v-model="description" v-validate="'required'" />
                        <p class="error" v-if="submitted" v-for="error in errors.collect('description')">{{ error }}</p>
                    </div>

                   <!--  <form class="mb-4" action="" method="post" enctype="multipart/form-data" id="UploadDocuments">
                        <div class="drag-drop">
                            <input class="file-upload-field" type="file" name="document" @change="onFileChange($event.target.files[0])" ref="testreport" v-validate="'required|image'">
                            <feather type="upload-cloud"></feather>
                            <h3 class="mt-4">Drag and Drop Files Files To Upload</h3>
                            <p>you can do this anytime without clicking upload</p>
                            <span class="d-block">or</span>
                            <button type="submit" class="btn btn btn-default btn-blue attach">Attach File</button>
                            <p class="error mt-3" v-if="submitted" v-for="error in errors.collect('document')">{{ error }}</p>
                        </div>
                    </form>
                    <div class="preview" v-if="fileName">
                        <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mb-4 p-2">
                            <div class="image-upload d-flex align-items-center">
                                <figure class="mb-0"><img src="../../../../../static/website/images/report.png" alt="" /></figure>
                                <h5>{{fileName}}</h5>
                            </div>
                            <div class="icons d-fle">
                                <a href="#" class="close-icon" @click="fileName = '';$refs.testreport.value = ''"><feather type="x"></feather></a>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group field-wrapper">
                        <input class="float-field form-control" type="time" :max="disableFutureTime" name="time"v-model="time" v-validate="'required'">
                        <p class="error" v-if="submitted && errors.has('time')">Time field is required </p>
                        <p class="error" v-if="submitted && selectFutureTime">Please Select time before current time</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm();selectFutureTime = false">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="SaveFoodData()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Food-Intake-Form",
        data() {
            return {
                pageLoader : false,
                submitted : false,
                food_item: '',
                description: '',
                fileName: '',
                time: '',
                disableFutureTime: moment().format("HH:mm"),
                selectFutureTime : false
            };
        },
        props:['from'],
        methods:{
            changeTime(){
                const d = new Date();
                if(this.time){
                    let hours = this.time.split(':')[0]
                    let minutes = this.time.split(':')[1]
                    if(this.$parent.filter == 'today'){
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }else{
                        d.setDate(d.getDate()-1);
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }
                }
                return d
            },
            onFileChange(event){
                var fileData =  event;
                this.fileName = fileData.name;
            },
            SaveFoodData(){
                const _that = this
                //let UploadReport = document.getElementById('UploadDocuments');
                let form_name = new FormData();
                //let form_data_get = form_name.get('document');
                _that.submitted = true;
                form_name.append("food_type" , _that.food_item);
                form_name.append("description" , _that.description);
                form_name.append("meal_time" , moment(_that.changeTime()).format('YYYY-MM-DD HH:mm'));
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const d = new Date();
                        let hrs = this.time.split(':')[0]
                        let mns = this.time.split(':')[1]
                        d.setHours(parseInt(hrs))
                        d.setMinutes(parseInt(mns))
                        if(this.from == 'daily-task' && this.$parent.filter == 'today' && moment(d).diff(moment(),'minutes') > 0){
                            this.selectFutureTime = true
                        }else{
                            this.selectFutureTime = false
                            let input_json = {
                                'globalParams' : {
                                    "form" : form_name,
                                },'localParams' : {'parameter' : _that, 'type' :'form'}
                            }
                            if(this.from){
                                input_json.localParams.from = this.from
                            }
                            this._runAddFoodIntake(input_json)
                        }
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.fileName = ''
                this.food_item = ''
                this.description = ''
                this.time = ''
                this.selectFutureTime = false
                //this.$refs.testreport.value = ''
            }   
        },
        created(){
           this.pageName('Input Food Intake Data')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/user/forms/food-intake.vue